export function getOrCreateUserId() {
    let userId = sessionStorage.getItem("userId");
    if (!userId) {
      userId = "UID_" + Date.now() + "_" + Math.floor(Math.random() * 100000);
      sessionStorage.setItem("userId", userId);
    }
    return userId;
  }
  